import { envelopeData } from '@/lib/envelope'
import { createFileRoute, Navigate } from '@tanstack/react-router'
import { useQuery } from '@tanstack/react-query'
import { communityChannelsQueryOptions } from '@/lib/queries/community'
import { Users } from 'lucide-react'

export const Route = createFileRoute('/_app/comunidade/')({
  component: CommunityIndex,
})

function CommunityIndex() {
  const { data: channelsData } = useQuery(communityChannelsQueryOptions())
  const channels = envelopeData(channelsData) ?? []

  if (channels.length > 0) {
    // rota tipada: template literal não entra na união do routeTree — o slug vai por `params`
    return <Navigate to="/comunidade/$channel" params={{ channel: channels[0].slug }} replace />
  }

  return (
    <div className="max-w-2xl mx-auto text-center py-16">
      <Users className="w-10 h-10 text-muted-foreground mx-auto mb-4" />
      <h1 className="text-xl font-semibold text-foreground mb-2">Comunidade</h1>
      <p className="text-muted-foreground">Nenhum canal disponivel ainda.</p>
    </div>
  )
}
